import {type ReactNode, useEffect, useRef, useState} from "react";

interface PanelProps {
    children: ReactNode;
    title?: string;
}

export function Panel({ children, title }: PanelProps) {
    const [isActive, setIsActive] = useState(false);
    const panelRef = useRef<HTMLDivElement>(null);

    const toggleActive = () => setIsActive(!isActive);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (panelRef.current && !panelRef.current.contains(event.target as Node)) {
                setIsActive(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div
            ref={panelRef}
            className={`algoliaPanel ${isActive ? "is-active" : ""}`}
        >
            {title && (
                <div className="algoliaPanel__header" onClick={toggleActive}>
                    {title}
                </div>
            )}
            <div className="algoliaPanel__body">{children}</div>
        </div>
    );
}